import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { UploadsCatalogKey } from './uploads.i18n.js';
import { UPLOADS_CATALOG } from './uploads.i18n.js';

export type UploadsMessageId = `uploads:${UploadsCatalogKey}`;

const PREFIX_LENGTH = 'uploads:'.length;

/** `t()` for the stop-gap `uploads:` scope (see `uploads.i18n.ts`). */
export function useUploadsT(): { t: (id: UploadsMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: UploadsMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as UploadsCatalogKey;
      const raw = UPLOADS_CATALOG[locale][key] ?? UPLOADS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
